export default __webpack_public_path__ + "static/marbel-markdown-cube-4c7c810bb0c784eca8acfc3f3c51058b.jpg";